/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoGearMiningLogListGearMiningLogData model module.
 * @module model/LogControllerDtoGearMiningLogListGearMiningLogData
 * @version 1.0
 */
class LogControllerDtoGearMiningLogListGearMiningLogData {
    /**
     * Constructs a new <code>LogControllerDtoGearMiningLogListGearMiningLogData</code>.
     * @alias module:model/LogControllerDtoGearMiningLogListGearMiningLogData
     */
    constructor() { 
        
        LogControllerDtoGearMiningLogListGearMiningLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoGearMiningLogListGearMiningLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoGearMiningLogListGearMiningLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoGearMiningLogListGearMiningLogData} The populated <code>LogControllerDtoGearMiningLogListGearMiningLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoGearMiningLogListGearMiningLogData();

            if (data.hasOwnProperty('logNo')) {
                obj['logNo'] = ApiClient.convertToType(data['logNo'], 'Number');
            }
            if (data.hasOwnProperty('postNo')) {
                obj['postNo'] = ApiClient.convertToType(data['postNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('miningAmount')) {
                obj['miningAmount'] = ApiClient.convertToType(data['miningAmount'], 'Number');
            }
            if (data.hasOwnProperty('bonusAmount')) {
                obj['bonusAmount'] = ApiClient.convertToType(data['bonusAmount'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoGearMiningLogListGearMiningLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoGearMiningLogListGearMiningLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}



/**
 * @member {Number} logNo
 */
LogControllerDtoGearMiningLogListGearMiningLogData.prototype['logNo'] = undefined;

/**
 * @member {Number} postNo
 */
LogControllerDtoGearMiningLogListGearMiningLogData.prototype['postNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoGearMiningLogListGearMiningLogData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
LogControllerDtoGearMiningLogListGearMiningLogData.prototype['email'] = undefined;

/**
 * @member {Number} miningAmount
 */
LogControllerDtoGearMiningLogListGearMiningLogData.prototype['miningAmount'] = undefined;

/**
 * @member {Number} bonusAmount
 */
LogControllerDtoGearMiningLogListGearMiningLogData.prototype['bonusAmount'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoGearMiningLogListGearMiningLogData.prototype['createdAt'] = undefined;






export default LogControllerDtoGearMiningLogListGearMiningLogData;

